<template>
  <section class="section-default"
           :class="{'bg-light2': background }">
    <div class="container container-small">
      <transition name="text" v-if="visible || mobile">
        <TextSection
          v-for="(section, index) in headers"
          :header="section.header"
          :description="section.description"
          :caption="section.caption"
          :smaller="section.smaller"
          :key="index" />
      </transition>
    </div>
    <transition name="pulse">
      <div class="bcg"
          :class="{'bcg-visible' : visible}">
        <img :src="image" alt="Section image">
        <img class="animated-circle" src="@/assets/images/fmk/section4/circle.png" alt="Section image">
        <img class="animated-circle-big" src="@/assets/images/fmk/section4/circle.png" alt="Section image">
      </div>
    </transition>
  </section>
</template>

<script>
import TextSection from '@/components/TextSection.vue'

export default {
  name: 'animatedSection',
  props: ['headers', 'image', 'visible', 'mobile', 'background'],
  components: {
    TextSection
  }
}
</script>

<style scoped lang="scss">
  .section-default {
    padding: 0;
    min-height: 680px;
    @include desktop-small {
      min-height: 400px;
    }
  }
  header {
    width: 300px;
    max-width: 90vw;
  }
  .bcg {
    position: absolute;
    width: 79vw;
    height: 100%;
    max-width: 980px;
    right: 0;
    top: 0;

    &:before {
      content: '';
      display: block;
      position: absolute;
      bottom: 10%;
      right: 0;
      width: 100%;
      height: 10vw;
      max-height: 80px;
      z-index: 1;
      background-color: $bg-accent;
    }
    img {
      position: absolute;
      display: block;
      bottom: 0;
      right: 0;
      max-height: 100%;
      max-width: 100%;
      height: auto;
      visibility: hidden;
      width: 100%;
      z-index: 2;
    }

    &-visible {
      img {
        visibility: visible;
      }
    } // END .bcg-visible;

    .animated-circle-big,
    .animated-circle {
      animation-name: circleRotation;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
      animation-duration: 22s;
    }
    .animated-circle {
      top: 20%;
      left: 22%;
      bottom: auto;
      right: auto;
      width: 40px;
      height: 40px;
      z-index: 1;
      animation-timing-function: linear;
      animation-delay: 11s;
      @include desktop-small {
        width: 5vw;
        height: 5vw;
        max-width: 20px;
        max-height: 20px;
      }
      @include tablet-only {
        top: 30%;
        left: 22%;
      }
    }
    .animated-circle-big {
      top: 30%;
      left: 26%;
      bottom: auto;
      right: auto;
      width: 152px;
      height: 152px;
      z-index: 1;
      @include desktop-small {
        width: 15vw;
        height: 15vw;
        max-width: 90px;
        max-height: 90px;
      }
      @include tablet-only {
        top: 44%;
        left: 26%;
      }
    }
    z-index: 0;
    @include desktop {
      width: 64vw;
    }
    @include desktop-small {
      width: 51vw;
      background-position: right bottom;
      background-size: contain;
    }
    @include mobile {
      width: 100%;
      display: block;
      position: relative;
      background-image: none !important;
      background-position: center;
      height: auto;
      img {
        display: block;
        position: relative;
        width: 100%;
        max-height: 100vh;
      }
      .animated-circle-big,
      .animated-circle {
        position: absolute;
      }
    }
  }
  section {
    position: relative;
    // min-height: 600px;
    padding: 0 0;
    .container {
      position: relative;
      padding: 113px 32vw 1px 0;
    }

    @include mobile {
      .container {
        padding: 60px 0 0 0;
      }
      /deep/ .multi {
        .parts-wrapper {
          min-height: 200px;
        }
      }
    }
    @include mobile-small {
      /deep/ .multi {
        .parts-wrapper {
          min-height: 250px;
        }
      }
    }
    .font-size-l & {
      @include screen('lg') {
        .bcg {
          width: 45vw;
        }
      }
      @include tablet {
        /deep/ .multi {
          .parts-wrapper {
            min-height: 230px;
          }
        }
      }
      @include mobile {
        .bcg {
          width: 100%;
        }
      }
      @include mobile-small {
        /deep/ .multi {
          .parts-wrapper {
            min-height: 250px;
          }
        }
      }
    }
  }
  @keyframes circleRotation
  {
    0%
    {
      transform: rotate(0);
    }
    50%
    {
      transform: rotate(180deg);
    }
    75%
    {
      transform: rotate(300deg);
    }
    100%
    {
      transform: rotate(360deg);
    }
  }
</style>
